import { HumanizedDateCell, TableSelectAllCheckbox } from '@/components/ui'
import type { ColumnDef } from '@/components/ui/table/types'
import { isSingleProjectPlan, type PlanKind } from '@/modules/account'
import type { Project } from '@/modules/projects'
import { ContextMenuCell } from './ContextMenuCell'
import { ExpirationCell } from './ExpirationCell'
import { NameCell } from './NameCell'
import { NumberOfPagesCell } from './NumberOfPagesCell'
import { RowActionsCell } from './RowActionsCell'
import { SelectCell } from './SelectCell'
import { StatusCell } from './StatusCell'

const baseColumns: ColumnDef<Project, any>[] = [
  {
    id: 'select',
    header: TableSelectAllCheckbox,
    cell: SelectCell,
    enableSorting: false,
    enableHiding: false,
    size: 50,
  },
  {
    accessorKey: 'name',
    header: 'Project Name',
    meta: { isFluid: true },
    size: 300,
    cell: ContextMenuCell(NameCell),
  },
  {
    accessorKey: 'createdAt',
    header: 'Creation Date',
    size: 150,
    cell: ContextMenuCell(HumanizedDateCell),
  },
  {
    accessorKey: 'firstProcessedAt',
    header: 'Processed Date',
    size: 150,
    cell: ContextMenuCell(HumanizedDateCell),
  },
  {
    accessorKey: 'numberOfPages',
    header: '# of Pages',
    size: 150,
    cell: ContextMenuCell(NumberOfPagesCell),
  },
  {
    accessorKey: 'status',
    header: 'Status',
    size: 200,
    cell: ContextMenuCell(StatusCell),
  },
]

// Projects only expire on the single-project plan, so the column is added
// only there — other plans would render an always-empty column.
const expirationColumn: ColumnDef<Project, any> = {
  accessorKey: 'expiresAt',
  header: 'Expiration Date',
  size: 220,
  cell: ContextMenuCell(ExpirationCell),
}

const actionsColumn: ColumnDef<Project, any> = {
  id: 'actions',
  header: '',
  size: 56,
  enableSorting: false,
  enableHiding: false,
  cell: RowActionsCell,
}

const folderColumn: ColumnDef<Project, any> = {
  accessorKey: 'folderName',
  header: 'Folder',
  size: 200,
  cell: ContextMenuCell(),
}

export const getProjectsColumns = (
  planKind?: PlanKind,
): ColumnDef<Project, any>[] =>
  isSingleProjectPlan(planKind)
    ? [...baseColumns, expirationColumn, actionsColumn]
    : [...baseColumns, actionsColumn]

export const getArchivedProjectsColumns = (
  planKind?: PlanKind,
): ColumnDef<Project, any>[] => {
  const [select, name, ...rest] = getProjectsColumns(planKind)
  return [select, name, folderColumn, ...rest]
}
